import {
    Sparkles,
    ShieldCheck,
    CircleCheck,
    CircleMinus,
    CircleDot,
    CircleSlash,
    BatteryMedium,
    BatteryFull,
    TrendingUp,
    HandCoins,
} from 'lucide-vue-next'

export const gradeConfig: Record<string, { label: string; abbr: string; icon: typeof Sparkles }> = {
    R: { label: 'New', abbr: 'New', icon: Sparkles },
    N: { label: 'Excellent', abbr: 'Exc.', icon: ShieldCheck },
    A: { label: 'Very Good', abbr: 'V.Good', icon: CircleCheck },
    B: { label: 'Good', abbr: 'Good', icon: CircleMinus },
    C: { label: 'Acceptable', abbr: 'Acc.', icon: CircleDot },
    D: { label: 'Broken', abbr: 'Broken', icon: CircleSlash },
}

export const batteryConfig: Record<string, { label: string; abbr: string; icon: typeof BatteryMedium }> = {
    std: { label: 'Used', abbr: 'Used', icon: BatteryMedium },
    premium: { label: 'New', abbr: 'New', icon: BatteryFull },
}

/**
 * One place for how a market side is worded and coloured, wherever it is shown.
 * `accent` carries the same hue as the badge variant for the places that dress a
 * heading or a section edge rather than a badge, so a side reads the same colour
 * whichever shape it takes on the page.
 */
export const sideConfig: Record<
    string,
    {
        label: string
        variant: 'resell' | 'tradein'
        icon: typeof TrendingUp
        accent: { text: string; rule: string; border: string }
    }
> = {
    resell: {
        label: 'Resell',
        variant: 'resell',
        icon: TrendingUp,
        accent: {
            text: 'text-resell-foreground',
            rule: 'bg-resell/30',
            border: 'border-l-resell',
        },
    },
    buyback: {
        label: 'Trade-in',
        variant: 'tradein',
        icon: HandCoins,
        accent: {
            text: 'text-tradein-foreground',
            rule: 'bg-tradein/30',
            border: 'border-l-tradein',
        },
    },
}

export const getBatteryConfig = (status: string | undefined) => {
    return batteryConfig[status ?? ''] ?? batteryConfig['premium']
}
